import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OpenApiService } from '@widgets/open-api.service';

export class JwtInfo {
  assignee: number;
  authKey: string; //guid
  exp: number;
  iat: number;
  iss: string;
  linkType: number;
  nbf: number;
  tenantSubscriptionId: number;
  turnoverDataBidId: number;
}
export class WidgetTurnBidResponce {
  assignee: number;
  bidInfo: {
    approved: boolean;
    bidAmount: number;
    bidDate: Date;
    id: number;
    invoices: any[];
    status: number;
    turnoverDataBidCategoryId: number;
    turnoverId: number;
    vendorId: number;
  };
  timeZone: {
    id: string;
    displayName: string;
    utcOffsetMinutes: number;
  };
  turnInfo: {};
  unitInfo: {
    unitName: string;
    unitType: string;
    propertyName: string;
    propertyAddress: {
      propertyToAddressLinkId: number;
      id: number;
      addressType: number;
      addressTypeUrn: string;
      title: string;
      street1: string;
      street2: string;
      city: string;
      state: string;
      zip: string;
      url: string;
    };
  };
  users: {
    userId: number;
    firstName: string;
    lastName: string;
    displayName: string;
    email: string;
  }[];
}

@Injectable({
  providedIn: 'root',
})
export class BidManagementService {
  constructor(protected service: OpenApiService) {}

  public getTurnInfo(jwtToken: string): Observable<WidgetTurnBidResponce> {
    return this.service.get(`bids/getTurnBidInfo?jwtToken=${jwtToken}`);
  }

  public comment(jwtToken: string, comment: string): Observable<null> {
    return this.service.post(`bids/comment?jwtToken=${jwtToken}`, { comment });
  }

  public accept(jwtToken: string): Observable<null> {
    return this.service.post(`bids/accept?jwtToken=${jwtToken}`);
  }

  public approve(jwtToken: string): Observable<null> {
    return this.service.post(`bids/approve?jwtToken=${jwtToken}`);
  }

  public reject(jwtToken: string, reason: string): Observable<null> {
    return this.service.post(`bids/reject?jwtToken=${jwtToken}`, { reason });
  }

  public deny(jwtToken: string, reason: string): Observable<null> {
    return this.service.post(`bids/deny?jwtToken=${jwtToken}`, { reason });
  }
}
